/**
 * 全角の混じった文字列を全て半角にして返却する
 * @param str 全角の混じった文字列
 * @returns
 */
export const convertZenkakuToHankaku = (str: string | undefined) => {
  if (!str) return '';
  let halfVal = str.replace(/[！-～]/g, function (tmpStr) {
    // 文字コードをシフト
    return String.fromCharCode(tmpStr.charCodeAt(0) - 0xfee0);
  });

  // 文字コードシフトで対応できない文字の変換
  return halfVal
    .replace(/”/g, '"')
    .replace(/’/g, "'")
    .replace(/‘/g, '`')
    .replace(/￥/g, '\\')
    .replace(/　/g, ' ')
    .replace(/〜/g, '~')
    .replace(/ー/g, '-');
};

/**
 * 半角の混じった文字列を全て全角にして返却する
 * @param str 半角の混じった文字列
 * @returns
 */
export const convertHankakuToZenkaku = (str: string | undefined) => {
  if (!str) return '';
  const multiByteStr = str.replace(/[!-~]/g, function (tmpStr) {
    return String.fromCharCode(tmpStr.charCodeAt(0) + 0xfee0);
  });

  return multiByteStr
    .replace(/"/g, '”')
    .replace(/'/g, '’')
    .replace(/`/g, '‘')
    .replace(/\\/g, '￥')
    .replace(/ /g, '　')
    .replace(/~/g, '〜')
    .replace(/-/g, 'ー');
};
